/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function($, Backbone) {
  "use strict";

  var ns;

  ns = window.nspace("ccc.viz.shared.models");

  /**
   * Records the data selector values representing the data set currently selected
   * by the user. The values in this model are represented in the URL.
   */
  ns.SelectorsModel = Backbone.Model.extend({
    /**
     * Checks if model arrays are in a valid state.
     * Set this.propNames if you want to limit which model properties are examined for validity.
     * See ccc.viz.profile.models.SelectorsModel for a working example.
     */
    areModelArraysValid: function() {
      var props, anyModelArrayIsInvalid;

      function convertPropNames(convertedPropNames) {
        if (!convertedPropNames) {
          return convertedPropNames;
        }

        if (!(convertedPropNames instanceof Array)) {
          return convertedPropNames.split(",");
        }

        return convertedPropNames;
      }

      props = convertPropNames(this.propNames);

      anyModelArrayIsInvalid = !_.any(this.attributes, function(value, key) {
        var shouldPropBeEvaluated;

        if (!(value instanceof Array)) {
          return false;
        }

        if (!props) {
          // If there's no length, we're in an invalid state.
          return !value.length;
        }

        shouldPropBeEvaluated = _.any(props, function(prop) {
          return prop === key;
        });

        if (shouldPropBeEvaluated) {
          return !value.length;
        }

        return false;
      });

      return anyModelArrayIsInvalid;
    }
  });
})(jQuery, Backbone);
